'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortArrows;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function SortArrows(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-sort-arrows ' + className, width: width, height: height, viewBox: '0 0 18 16' },
    _react2.default.createElement('path', { fill: color, d: 'M12 7l-4-4-4 4zM4 10l4 4 4-4z' })
  );
}

SortArrows.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Sort/SortArrows.js
// module id = 334
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16